import { render } from "./CurrencyRecord.vue?vue&type=template&id=d75d1d70"
import script from "./CurrencyRecord.vue?vue&type=script&lang=js"
export * from "./CurrencyRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__